var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2196_112895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#FCFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61516 12.5146C4.10154 15.785 2.20616 19.5544 1.10254 23.6493H17.7498L6.61516 12.5146Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8986 23.6494C61.795 19.5546 59.8995 15.7853 57.386 12.5149L46.2516 23.6494H62.8986Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.10254 40.3472C2.20629 44.4419 4.10167 48.2113 6.61517 51.4815L17.7494 40.3472H1.10254Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4816 6.61261C48.2112 4.09898 44.4419 2.2036 40.347 1.09985V17.747L51.4816 6.61261Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5172 57.3803C15.7876 59.894 19.557 61.7893 23.6517 62.8931V46.2461L12.5172 57.3803Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6516 1.09985C19.5568 2.2036 15.7875 4.09898 12.5172 6.61247L23.6516 17.7468V1.09985Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.347 62.8931C44.4418 61.7893 48.2112 59.894 51.4814 57.3805L40.347 46.2461V62.8931Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2516 40.3472L57.386 51.4816C59.8995 48.2114 61.795 44.4419 62.8986 40.3472H46.2516Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7291 27.8261H36.1741H36.174V0.270875C34.8076 0.093 33.4146 0 32 0C30.5851 0 29.1924 0.093 27.8261 0.270875V27.8259V27.826H0.270875C0.093 29.1924 0 30.5854 0 32C0 33.4149 0.093 34.8076 0.270875 36.1739H27.8259H27.826V63.7291C29.1924 63.907 30.5851 64 32 64C33.4146 64 34.8076 63.9071 36.1739 63.7291V36.1741V36.174H63.7291C63.907 34.8076 64 33.4149 64 32C64 30.5854 63.907 29.1924 63.7291 27.8261Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3477 40.35L54.6272 54.6295C55.2839 53.973 55.9104 53.2866 56.5082 52.5751L44.2829 40.3499H40.3477V40.35Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6521 40.3499H23.6518L9.37244 54.6292C10.0289 55.286 10.7153 55.9125 11.4268 56.5102L23.6521 44.2847V40.3499Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6517 23.651V23.6507L9.37221 9.37109C8.71546 10.0276 8.08896 10.714 7.49121 11.4255L19.7166 23.6508H23.6517V23.651Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3477 23.6538L54.6273 9.37404C53.9708 8.71729 53.2844 8.09079 52.5729 7.49316L40.3477 19.7185V23.6538Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2196_112895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.834bd74a85ca57f055e53ab98e872ab4.svg";
export { ForwardRef as ReactComponent };